import $ from 'jquery'
import "moment/min/locales";
import "xlsx/dist/xlsx.full.min.js";
import Dropzone from "./Dropzone.js";
import Loading from "../ui/Loading.js";
import { Redirect } from "react-router-dom";
import * as Utils from '../../commons/utils/Utils'
import backendStrings from '../../lang/backendStrings.js';
import { FormattedMessage, injectIntl } from "react-intl";
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import Security from '../../commons/security/Security.js'
import { ITEM_TIPO_PRODUCTO, ITEM_TIPO_MANO_DE_OBRA, esManoDeObra } from '../../commons/constants/itemsTipos.js'
import { permisosCargaPorMomento } from '../../commons/constants/presupuestoCarga.js'
import { tieneMezclaValidacionAutomatica } from '../presupuestoDetallado/mezclaValidacionAutomatica.js'
import React, { useState, useEffect, useLayoutEffect } from "react";
import PresupuestoDetalladoItem from "../presupuestoDetallado/PresupuestoDetalladoItem.js";
import PresupuestoDetalladoTarea from "../presupuestoDetallado/PresupuestoDetalladoTarea.js";
import Swal from 'sweetalert2';
import { formatCost } from '../../commons/utils/Helpers.js';

const FORM_DATA_INIT = {
	id: null,
	manoDeObra: 0,
	repuestos: 0,
	impuestos: 0,
	otros: 0,
	adjunto: null,
	adicional: false,
	presupuestoItems: [],
	presupuestoTareas: []

}

const requiredSymbol = ' *';

const TicketPresupuestoDetallado = (props) => {
  	const intl = props.intl;
	const [loading, setLoading] = useState(false);
  	const [redirectTo, setRedirectTo] = useState(null);
	const [presupuestoItems, setPresupuestoItems] = useState([]);
	const [presupuestoTareas, setPresupuestoTareas] = useState([]);
	const [presupuestoItemsManoDeObra, setPresupuestoItemsManoDeObra] = useState([]);
	const [formData, setFormData] =  useState({ ...FORM_DATA_INIT });
	const [totalRepuestos, setTotalRepuestos] = useState(0);
	const [totalManoObra, setTotalManoObra] = useState(0);
	const [totalManoDeObraItems, setTotalManoDeObraItems] = useState(0);
	const [totalTareas, setTotalTareas] = useState(0);
	const [impuestos, setImpuestos] = useState(0);
	const [otros, setOtros] = useState(0);
	const [total, setTotal] = useState(0);
	const [adjunto, setAdjunto] = useState(null);
	const [errors, setErrors] = useState([]);
	const [enabledItems, setEnabledItems] = useState(false);
	const [enabledTareas, setEnabledTareas] = useState(false);
	const [showItems, setShowItems] = useState([]);
	const [obligatoriosItem, setObligatoriosItem] = useState([]);
	const [showTareas, setShowTareas] = useState([]);
	const [obligatoriosTarea, setObligatoriosTarea] = useState([]);
	const [presupuestoIdActual, setPresupuestoIdActual] = useState(null);
	const [esRecotizacionParcial, setEsRecotizacionParcial] = useState(false);
	// VEC-3231: momento (inicial/adicional) real del borrador precargado, tomado del backend
	// (existeAprobado), para gris­ear por el permiso correcto sin depender solo de canDo('PRESUPUESTAR_ADIC').
	const [adicionalBorrador, setAdicionalBorrador] = useState(null);
	const obligatoriedadMutuaTareaItem = ConfigBusiness.get('tickets.presupuesto.obligatoriedadMutuaTareaItem') === 'true' ? true : false;
	const trabajaConManoDeObra = ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true';
	// VEC-3231: feature flag por cliente. Si no está en 'true', no hay borrador ni carga parcial (legacy).
	const borradorHabilitado = ConfigBusiness.get('tickets.presupuesto.borrador.habilitado') === 'true';
	// VEC-3231: momento (inicial/adicional) autoritativo del próximo presupuesto, calculado por el backend
	// (existeAprobado) y pasado por el padre. Es la fuente única de verdad para el griseo por permiso y
	// para el nextState al enviar; null si el padre todavía no lo resolvió.
	const momentoAdicionalProp = (props.momentoAdicional === true || props.momentoAdicional === false) ? props.momentoAdicional : null;

	useEffect(() => {
	  	init();
  	}, []);

	// Inicializar tooltips cuando se agregan/modifican items o tareas
	useLayoutEffect(() => {
		// Destruir tooltips existentes primero
		$('[data-tooltip="tooltip"]').tooltip('dispose');
		
		// Pequeño delay para asegurar que el DOM esté actualizado
		const timer = setTimeout(() => {
			$('[data-tooltip="tooltip"]').tooltip();
		}, 100);
		
		return () => clearTimeout(timer);
	}, [presupuestoItems, presupuestoTareas]);
	
	const init = () => {
		setImpuestos(0)
		setOtros(0)
		setAdjunto(null)
		setErrors([])
		let enabledItems = ConfigBusiness.get('tickets.presupuesto.items.habilitado') === 'true';
		let showItems = [];
		if(enabledItems){
			showItems = ConfigBusiness.get('tickets.presupuesto.items.show').split(',');
			setShowItems(showItems);
			let obligatorios = ConfigBusiness.get('tickets.presupuesto.items.obligatorios').split(',');
			obligatorios = obligatorios.filter((element) => showItems.includes(element));
			setObligatoriosItem(obligatorios);
		}
		setEnabledItems(enabledItems);

		let enabledTareas = ConfigBusiness.get('tickets.presupuesto.tareas.habilitado') === 'true'
		let showTareas = [];
		if(enabledTareas){
			showTareas = ConfigBusiness.get('tickets.presupuesto.tareas.show').split(',');
			setShowTareas(showTareas);
			let obligatorios = ConfigBusiness.get('tickets.presupuesto.tareas.obligatorios').split(',');
			obligatorios = obligatorios.filter((element) => showTareas.includes(element));
			setObligatoriosTarea(obligatorios);
		}
		setEnabledTareas(enabledTareas);

		if(props.ticket.presupuestoNombre && props.ticket.estado === 'RECOTIZAR'){
			// Recotización parcial: cargar ítems del presupuesto activo (Pendiente) para edición
			setLoading(true);
			Utils.getData('/ticket-presupuestos/ticket/' + props.ticket.id + '/items-activos')
				.then(function(data) {
					if (!data) { setLoading(false); return; }
					setPresupuestoIdActual(data.presupuestoId || null);
					if (data.impuestos) setImpuestos(data.impuestos);
					if (data.otros) setOtros(data.otros);
					var items = (data.items || []).map(function(pItem) {
						return {
							'cantidad': pItem.cantidad,
							'costo': pItem.precio, 'detalle': pItem.detalle || '',
							'descripcion': pItem.descripcion,
							'external_code': pItem.external_code,
							'id': pItem.id_item,
							'id_item': pItem.id_item,
							'servicio_id': pItem.servicio_id,
							'servicio_nombre': pItem.servicio ? pItem.servicio.nombre : null,
							'validacion_automatica': pItem.servicio ? pItem.servicio.validacion_automatica : null,
							'estado_recotizacion': pItem.estado_recotizacion || null,
							'comentario_rechazo': pItem.comentario_rechazo || null,
							'costo_fijo': pItem.item ? pItem.item.costo_fijo : null,
							'idPresupuestoItem': pItem.id,
							'idPresupuesto': pItem.id_presupuesto,
							'clasificacion': pItem.clasificacion && pItem.clasificacion.nombre ? pItem.clasificacion.nombre : '',
							// Se setean ambos campos con el mismo valor porque el endpoint de guardado lee
							// 'id_clasificacion' y el edit modal inicializa desde 'id_item_clasificacion'.
							// La API devuelve snake_case (toArray), no el camelCase de jsonSerialize (VEC-3258).
							// TODO VEC-3278: unificar ambos consumidores (guardado y edit modal) en un único campo y eliminar la duplicación.
							'id_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'id_item_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'mecanico_ids': pItem.mecanicos ? pItem.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tareas = (data.tareas || []).map(function(pTarea) {
						return {
							'id_tarea': pTarea.id_tarea,
							'external_code': pTarea.external_code,
							'nombre': pTarea.descripcion,
							'cuenta_mayor': pTarea.servicio_external_code,
							'cuenta_mayor_descripcion': pTarea.servicio ? pTarea.servicio.nombre : null,
							'precio': pTarea.precio, 'detalle': pTarea.detalle || '',
							'cantidad': pTarea.cantidad || 1,
							'servicio_id': pTarea.servicio_id,
							'servicio_nombre': pTarea.servicio ? pTarea.servicio.nombre : null,
							'validacion_automatica': pTarea.servicio ? pTarea.servicio.validacion_automatica : null,
							'estado_recotizacion': pTarea.estado_recotizacion || null,
							'comentario_rechazo': pTarea.comentario_rechazo || null,
							'idPresupuestoTarea': pTarea.id,
							'idPresupuesto': pTarea.id_presupuesto,
							'mecanico_ids': pTarea.mecanicos ? pTarea.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tieneRechazado = items.some(function(i) { return i.estado_recotizacion === 'rechazado'; })
						|| tareas.some(function(t) { return t.estado_recotizacion === 'rechazado'; });
					setEsRecotizacionParcial(tieneRechazado);
					setPresupuestoItems(items);
					setPresupuestoTareas(tareas);
					calculateTotal(items, tareas, data.impuestos || 0, data.otros || 0);
					setLoading(false);
				})
				.catch(function() { setLoading(false); });
		} else if(!props.ticket.presupuestoNombre){
			setLoading(true)
			Promise.all([
				((props.ticket.ticketTipo === 'PREVENTIVO' || props.ticket.ticketTipo === 'CORRECTIVO' || props.ticket.ticketTipo === 'VENCIMIENTO' || props.ticket.ticketTipo === 'PREDICTIVO') && props.ticket.servicio && enabledItems) ? Utils.getData(`/items/items-and-servicio-by-ticket/${props.ticket.id}`) : [],
				(props.ticket.ticketTipo === 'PREVENTIVO' || props.ticket.ticketTipo === 'CORRECTIVO' || props.ticket.ticketTipo === 'VENCIMIENTO' || props.ticket.ticketTipo === 'PREDICTIVO') ? Utils.getData(`/tareas/tareas-and-servicio-by-ticket/${props.ticket.id}`) : [],
				Utils.getData(`/ticket-presupuestos/ticket/${props.ticket.id}/items-activos`),
				Utils.getData(`/ticket-presupuestos/ticket/${props.ticket.id}/precargar-items`),
			])
			.then((data) => {
				// data[2] = items-activos (presupuesto Pendiente: recotización parcial con estados)
				// data[3] = precargar-items (último presupuesto Rechazado: recotización total)
				const itemsActivos  = (data[2] && data[2].items)  ? data[2].items  : [];
				const tareasActivas = (data[2] && data[2].tareas) ? data[2].tareas : [];
				const precargaItems  = (data[3] && data[3].items)  ? data[3].items  : [];
				const precargaTareas = (data[3] && data[3].tareas) ? data[3].tareas : [];

				// VEC-3398: /items-activos devuelve el último presupuesto SIN filtro de estado. Si ese
				// presupuesto ya está Aprobado/Auto-Aprobado no es una recotización en curso y NO debe
				// precargarse. Pasa cuando el ticket quedó con presupuesto_nombre vacío (p.ej. fue
				// rechazado y luego auto-aprobado) y cae en esta rama creyendo que no tiene presupuesto.
				const estadoActivos = (data[2] && data[2].estado) ? data[2].estado : null;
				const esPresupuestoCerrado = estadoActivos === 'Aprobado' || estadoActivos === 'Auto-Aprobado';

				// Prioridad 1: presupuesto activo (parcial) — preserva estado_recotizacion y comentario_rechazo
				if (!esPresupuestoCerrado && (itemsActivos.length > 0 || tareasActivas.length > 0)) {
					if (data[2].impuestos) setImpuestos(data[2].impuestos);
					if (data[2].otros) setOtros(data[2].otros);
					var items = itemsActivos.map(function(pItem) {
						return {
							'cantidad': pItem.cantidad,
							'costo': pItem.precio, 'detalle': pItem.detalle || '',
							'descripcion': pItem.descripcion,
							'external_code': pItem.external_code,
							'id': pItem.id_item,
							'id_item': pItem.id_item,
							'tipo': pItem.item ? pItem.item.tipo : null,
							'servicio_id': pItem.servicio_id,
							'servicio_nombre': pItem.servicio ? pItem.servicio.nombre : null,
							'validacion_automatica': pItem.servicio ? pItem.servicio.validacion_automatica : null,
							'estado_recotizacion': pItem.estado_recotizacion || null,
							'comentario_rechazo': pItem.comentario_rechazo || null,
							'costo_fijo': pItem.item ? pItem.item.costo_fijo : null,
							'clasificacion': pItem.clasificacion && pItem.clasificacion.nombre ? pItem.clasificacion.nombre : '',
							// Se setean ambos campos con el mismo valor porque el endpoint de guardado lee
							// 'id_clasificacion' y el edit modal inicializa desde 'id_item_clasificacion'.
							// La API devuelve snake_case (toArray), no el camelCase de jsonSerialize (VEC-3258).
							// TODO VEC-3278: unificar ambos consumidores (guardado y edit modal) en un único campo y eliminar la duplicación.
							'id_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'id_item_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'mecanico_ids': pItem.mecanicos ? pItem.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tareas = tareasActivas.map(function(pTarea) {
						return {
							'id_tarea': pTarea.id_tarea,
							'external_code': pTarea.external_code,
							'nombre': pTarea.descripcion,
							'cuenta_mayor': pTarea.servicio_external_code,
							'cuenta_mayor_descripcion': pTarea.servicio ? pTarea.servicio.nombre : null,
							'precio': pTarea.precio, 'detalle': pTarea.detalle || '',
							'cantidad': pTarea.cantidad || 1,
							'servicio_id': pTarea.servicio_id,
							'servicio_nombre': pTarea.servicio ? pTarea.servicio.nombre : null,
							'validacion_automatica': pTarea.servicio ? pTarea.servicio.validacion_automatica : null,
							'estado_recotizacion': pTarea.estado_recotizacion || null,
							'comentario_rechazo': pTarea.comentario_rechazo || null,
							'mecanico_ids': pTarea.mecanicos ? pTarea.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tieneRechazadoActivos = items.some(function(i) { return i.estado_recotizacion === 'rechazado'; })
						|| tareas.some(function(t) { return t.estado_recotizacion === 'rechazado'; });
					setEsRecotizacionParcial(tieneRechazadoActivos);
					if (trabajaConManoDeObra) {
						var itemsProducto = items.filter(function(i) { return !esManoDeObra(i.tipo); });
						var itemsMO = items.filter(function(i) { return esManoDeObra(i.tipo); });
						setPresupuestoItems(itemsProducto);
						setPresupuestoItemsManoDeObra(itemsMO);
						calculateTotal(itemsProducto, tareas, data[2].impuestos || 0, data[2].otros || 0, itemsMO);
					} else {
						setPresupuestoItems(items);
						calculateTotal(items, tareas, data[2].impuestos || 0, data[2].otros || 0);
					}
					setPresupuestoTareas(tareas);
					return;
				}

				// Prioridad 2: último presupuesto rechazado (total) — preserva precios del proveedor.
				// VEC-3398: igual que la Prioridad 1, si el último presupuesto ya está Aprobado/Auto-Aprobado
				// no hay recotización en curso y NO debe precargarse un rechazado histórico de un ciclo
				// anterior (pasa cuando el ticket cae en esta rama por presupuesto_nombre vacío). El flujo
				// legítimo de recotización total tiene el último presupuesto en Rechazado (no cerrado).
				if (!esPresupuestoCerrado && (precargaItems.length > 0 || precargaTareas.length > 0)) {
					var itemsPrecargados = precargaItems.map(function(pItem) {
						return {
							'cantidad': pItem.cantidad,
							'costo': pItem.precio, 'detalle': pItem.detalle || '',
							'descripcion': pItem.descripcion,
							'external_code': pItem.external_code,
							'id': pItem.id_item,
							'id_item': pItem.id_item,
							'tipo': pItem.item ? pItem.item.tipo : null,
							'servicio_id': pItem.servicio_id,
							'servicio_nombre': pItem.servicio ? pItem.servicio.nombre : null,
							'validacion_automatica': pItem.servicio ? pItem.servicio.validacion_automatica : null,
							'costo_fijo': pItem.item ? pItem.item.costo_fijo : null,
							'clasificacion': pItem.clasificacion && pItem.clasificacion.nombre ? pItem.clasificacion.nombre : '',
							// Se setean ambos campos con el mismo valor porque el endpoint de guardado lee
							// 'id_clasificacion' y el edit modal inicializa desde 'id_item_clasificacion'.
							// La API devuelve snake_case (toArray), no el camelCase de jsonSerialize (VEC-3258).
							// TODO VEC-3278: unificar ambos consumidores (guardado y edit modal) en un único campo y eliminar la duplicación.
							'id_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'id_item_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'mecanico_ids': pItem.mecanicos ? pItem.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tareasPrecargadas = precargaTareas.map(function(pTarea) {
						return {
							'id_tarea': pTarea.id_tarea,
							'external_code': pTarea.external_code,
							'nombre': pTarea.descripcion,
							'cuenta_mayor': pTarea.servicio_external_code,
							'cuenta_mayor_descripcion': pTarea.servicio ? pTarea.servicio.nombre : null,
							'precio': pTarea.precio, 'detalle': pTarea.detalle || '',
							'cantidad': pTarea.cantidad || 1,
							'servicio_id': pTarea.servicio_id,
							'servicio_nombre': pTarea.servicio ? pTarea.servicio.nombre : null,
							'validacion_automatica': pTarea.servicio ? pTarea.servicio.validacion_automatica : null,
							'mecanico_ids': pTarea.mecanicos ? pTarea.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					if (trabajaConManoDeObra) {
						var precargaProducto = itemsPrecargados.filter(function(i) { return !esManoDeObra(i.tipo); });
						var precargaMO = itemsPrecargados.filter(function(i) { return esManoDeObra(i.tipo); });
						setPresupuestoItems(precargaProducto);
						setPresupuestoItemsManoDeObra(precargaMO);
						calculateTotal(precargaProducto, tareasPrecargadas, 0, 0, precargaMO);
					} else {
						setPresupuestoItems(itemsPrecargados);
						calculateTotal(itemsPrecargados, tareasPrecargadas, 0, 0);
					}
					setPresupuestoTareas(tareasPrecargadas);
					return;
				}

				// Sin presupuesto anterior: cargar desde catálogo (primer presupuesto)
				var items = [];
				if(data[0]){
					data[0].forEach(element => {
						let cantidad = showTareas.includes('cantidad') ? (element.cantidad ? element.cantidad : "1") : "1"
						let costo = element.costo ? element.costo : "0";
						items.push({
							'cantidad': cantidad,
							'costo': costo,
							'cuenta_mayor': element.cuenta_mayor,
							'cuenta_mayor_descripcion': element.cuenta_mayor_descripcion,
							'descripcion': element.descripcion,
							'external_code': element.external_code,
							'id': element.id,
							'id_item': element.id_item,
							'marca': element.marca,
							'marcaNombre': element.marcaNombre,
							'numero_parte': element.numero_parte,
							'referencia': element.referencia,
							'servicio_id': element.servicio_id,
							'servicio_nombre': element.servicio_nombre,
							'servicio': { id: element.servicio_id, nombre: element.servicio_nombre },
							'validacion_automatica': element.validacion_automatica,
							'subcategoria': element.subcategoria,
							'tipo': element.tipo,
							'unidad': element.unidad,
							'costo_fijo': element.costo_fijo,
						});
					});
				}
				setPresupuestoItems(items);
				var tareas = [];
				if(data[1]){
					data[1].forEach(element => {
						let cantidad = showItems.includes('cantidad') ? (element.cantidad ? element.cantidad : "1") : "1"
						let precio = element.precio ? element.precio : "0";
						tareas.push({
							'id_tarea': element.id,
							'external_code': element.external_code,
							'nombre': element.nombre,
							'cuenta_mayor': element.servicio_external_code,
							'cuenta_mayor_descripcion': element.servicio_nombre,
							'precio': precio,
							'cantidad': cantidad,
							'servicio_id': element.servicio_id,
							'servicio_nombre': element.servicio_nombre,
							'validacion_automatica': element.validacion_automatica,
						});
					});
				}
				setPresupuestoTareas(tareas);
				if (trabajaConManoDeObra) {
					let itemsProducto = [];
					let itemsManoDeObra = [];
					items.forEach(function(item) {
						if (esManoDeObra(item.tipo)) {
							itemsManoDeObra.push(item);
						} else {
							itemsProducto.push(item);
						}
					});
					setPresupuestoItems(itemsProducto);
					setPresupuestoItemsManoDeObra(itemsManoDeObra);
					calculateTotal(itemsProducto, tareas, 0, 0, itemsManoDeObra);
				} else {
					setPresupuestoItems(items);
					calculateTotal(items, tareas, 0, 0, []);
				}
			})
			.catch((err) => {
				setLoading(false)
			}).finally(() => {
				setLoading(false)
			});
		} else if (borradorHabilitado) {
			// VEC-3231: ticket que YA tiene presupuesto y no está en recotización (ej. adicional sobre
			// aprobado). Si el último presupuesto es un BORRADOR, precargar sus ítems/tareas. Reusa
			// /items-activos (devuelve el último presupuesto, incluido el borrador). Las ramas de
			// recotización de arriba quedan intactas; esta rama solo cubre el hueco que antes no precargaba.
			setLoading(true);
			Utils.getData('/ticket-presupuestos/ticket/' + props.ticket.id + '/items-activos')
				.then(function(data) {
					if (data && data.estado === 'Borrador' && ((data.items && data.items.length > 0) || (data.tareas && data.tareas.length > 0))) {
						setPresupuestoIdActual(data.presupuestoId || null);
						setAdicionalBorrador(data.adicional ? true : false);
						if (data.impuestos) setImpuestos(data.impuestos);
						if (data.otros) setOtros(data.otros);
						var items = (data.items || []).map(function(pItem) {
							return {
								'cantidad': pItem.cantidad,
								'costo': pItem.precio, 'detalle': pItem.detalle || '',
								'descripcion': pItem.descripcion,
								'external_code': pItem.external_code,
								'id': pItem.id_item,
								'id_item': pItem.id_item,
								'tipo': pItem.item ? pItem.item.tipo : null,
								'servicio_id': pItem.servicio_id,
								'servicio_nombre': pItem.servicio ? pItem.servicio.nombre : null,
								'validacion_automatica': pItem.servicio ? pItem.servicio.validacion_automatica : null,
								'costo_fijo': pItem.item ? pItem.item.costo_fijo : null,
								'clasificacion': pItem.clasificacion && pItem.clasificacion.nombre ? pItem.clasificacion.nombre : '',
								'id_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
								'id_item_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							};
						});
						var tareas = (data.tareas || []).map(function(pTarea) {
							return {
								'id_tarea': pTarea.id_tarea,
								'external_code': pTarea.external_code,
								'nombre': pTarea.descripcion,
								'cuenta_mayor': pTarea.servicio_external_code,
								'cuenta_mayor_descripcion': pTarea.servicio ? pTarea.servicio.nombre : null,
								'precio': pTarea.precio, 'detalle': pTarea.detalle || '',
								'cantidad': pTarea.cantidad || 1,
								'servicio_id': pTarea.servicio_id,
								'servicio_nombre': pTarea.servicio ? pTarea.servicio.nombre : null,
								'validacion_automatica': pTarea.servicio ? pTarea.servicio.validacion_automatica : null,
							};
						});
						if (trabajaConManoDeObra) {
							var itemsProducto = items.filter(function(i) { return !esManoDeObra(i.tipo); });
							var itemsMO = items.filter(function(i) { return esManoDeObra(i.tipo); });
							setPresupuestoItems(itemsProducto);
							setPresupuestoItemsManoDeObra(itemsMO);
							calculateTotal(itemsProducto, tareas, data.impuestos || 0, data.otros || 0, itemsMO);
						} else {
							setPresupuestoItems(items);
							calculateTotal(items, tareas, data.impuestos || 0, data.otros || 0);
						}
						setPresupuestoTareas(tareas);
					}
					setLoading(false);
				})
				.catch(function() { setLoading(false); });
		}
	};

	const calculateTotal = (items, tareas, impuestosActual, otrosActual, itemsManoDeObra) => {
		var itemsMdo = itemsManoDeObra ? itemsManoDeObra : [];

		let totalRepuestosNew = 0;
		items.forEach(element => {
			if(element.cantidad){
				if(element.costo){
					totalRepuestosNew += element.cantidad*element.costo
				}
			}
		});
		setTotalRepuestos(totalRepuestosNew);

		let totalItemsManoDeObra = 0;
		itemsMdo.forEach(element => {
			if(element.cantidad){
				if(element.costo){
					totalItemsManoDeObra += element.cantidad*element.costo
				}
			}
		});
		setTotalManoDeObraItems(totalItemsManoDeObra);

		let totalTareasNew = 0;
		tareas.forEach(element => {
			if(element.precio){
				totalTareasNew += element.cantidad*parseFloat(element.precio)
			}
		});
		setTotalTareas(totalTareasNew);
		let totalManoObraNew = totalItemsManoDeObra + totalTareasNew;
		setTotalManoObra(totalManoObraNew);

		let totalNew = 0;
		totalNew = totalRepuestosNew + totalManoObraNew + parseFloat(impuestosActual) + parseFloat(otrosActual);

		setTotal(totalNew)
  };

	const deleteServicioItem = (indexArray) => {
		let items = [];
		presupuestoItems.forEach((element, index) => {
			if (index!==indexArray) {
				items.push(element);
			}
		});
		calculateTotal(items, presupuestoTareas, impuestos, otros, presupuestoItemsManoDeObra);
		setPresupuestoItems(items);
  };

	const addPresupuestoRepuesto = (newServicioItem) => {
		let copy = JSON.parse(JSON.stringify(presupuestoItems));
		var entrada = Object.assign({}, newServicioItem);
		if (esRecotizacionParcial) {
			entrada.estado_recotizacion = 'nuevo';
		}
		copy.push(entrada);
		calculateTotal(copy, presupuestoTareas, impuestos, otros, presupuestoItemsManoDeObra);
		setPresupuestoItems(copy);
  };

	const addPresupuestoManoDeObraItem = (newItem) => {
		let copy = JSON.parse(JSON.stringify(presupuestoItemsManoDeObra));
		var entrada = Object.assign({}, newItem);
		if (esRecotizacionParcial) {
			entrada.estado_recotizacion = 'nuevo';
		}
		copy.push(entrada);
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros, copy);
		setPresupuestoItemsManoDeObra(copy);
	};

	const deletePresupuestoManoDeObraItem = (indexArray) => {
		let items = [];
		presupuestoItemsManoDeObra.forEach((element, index) => {
			if (index !== indexArray) {
				items.push(element);
			}
		});
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros, items);
		setPresupuestoItemsManoDeObra(items);
	};

	const updatePresupuestoManoDeObraItem = (data, index) => {
		if(data.cantidad !== undefined) presupuestoItemsManoDeObra[index].cantidad = data.cantidad;
		if(data.costo !== undefined) presupuestoItemsManoDeObra[index].costo = data.costo;
		if(data.detalle !== undefined) presupuestoItemsManoDeObra[index].detalle = data.detalle || '';
		if(data.mecanico_ids !== undefined) presupuestoItemsManoDeObra[index].mecanico_ids = data.mecanico_ids;
		if(data.clasificacion !== undefined) presupuestoItemsManoDeObra[index].clasificacion = data.clasificacion;
		if(data.id_clasificacion !== undefined) presupuestoItemsManoDeObra[index].id_clasificacion = data.id_clasificacion;
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros, presupuestoItemsManoDeObra);
	};

	const addPresupuestoTarea = (newPresupuestoTarea) => {
		let copy = JSON.parse(JSON.stringify(presupuestoTareas));
		var entrada = Object.assign({}, newPresupuestoTarea);
		if (esRecotizacionParcial) {
			entrada.estado_recotizacion = 'nuevo';
		}
		copy.push(entrada);
		calculateTotal(presupuestoItems, copy, impuestos, otros, presupuestoItemsManoDeObra);
		setPresupuestoTareas(copy);
  };

	const handleCancel = (newServicioItem) => {
		props.callbackClose();
		init();
  };

	const deletePresupuestoTareas = (indexArray) => {
		let tareas = [];
		presupuestoTareas.forEach((element, index) => {
			if (index!==indexArray) {
				tareas.push(element);
			}
		});
		calculateTotal(presupuestoItems, tareas, impuestos, otros, presupuestoItemsManoDeObra);
		setPresupuestoTareas(tareas);
  };

	const handleFormChangeImpuestos = (value) =>  {
		calculateTotal(presupuestoItems, presupuestoTareas, value ? value : 0, otros, presupuestoItemsManoDeObra);
		setImpuestos(value ? value : formatCost(0))
	}

	const handleFormChangeOtros = (value) =>  {
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, value ? value : 0, presupuestoItemsManoDeObra);
		setOtros(value ? value : formatCost(0))	
	}

	const validate = () => {
		if(ConfigBusiness.get('tickets.presupuesto.adjuntoObligatorio') === 'true' && !adjunto)
			return true;
		var totalItems = presupuestoItems.length + presupuestoItemsManoDeObra.length;
		if(obligatoriedadMutuaTareaItem){
			if(enabledItems){
				if (totalItems === 0) {
					return true;
				}
			}
			if(enabledTareas){
				if (presupuestoTareas.length === 0) {
					return true;
				}
			}
		}else{
			if(enabledItems && enabledTareas){
				if (!(totalItems > 0 || presupuestoTareas.length > 0)) {
					return true;
				}
			}
		}
		return false;
	}

	const detectarMezclaValidacionAutomatica = () => {
		// VEC-3738: con trabajaConManoDeObra los ítems de mano de obra viven en su propio state
		// (presupuestoItemsManoDeObra), separados de los de repuestos. Sin incluirlos acá el modal
		// no aparecía cuando la mezcla estaba entre un repuesto y una mano de obra, ni cuando estaba
		// entre dos líneas de mano de obra: sólo se detectaba dentro de los repuestos.
		// Mismo criterio que usa el payload en ejecutarGuardado.
		const itemsDeTodoTipo = trabajaConManoDeObra
			? presupuestoItems.concat(presupuestoItemsManoDeObra)
			: presupuestoItems;
		return tieneMezclaValidacionAutomatica([...itemsDeTodoTipo, ...presupuestoTareas]);
	}

	const ejecutarGuardado = (esBorrador) => {
		setLoading(true);
		let formDataCopy = JSON.parse(JSON.stringify(formData));
		formDataCopy.id = props.ticket.id
		formDataCopy.manoDeObra = totalManoObra
		formDataCopy.repuestos = totalRepuestos
		formDataCopy.impuestos = impuestos
		formDataCopy.otros = otros
		formDataCopy.adicional = false
		// VEC-3565: en recotización parcial las líneas APROBADAS no se envían. Son propiedad del backend,
		// que las reinserta desde el presupuesto parcial rechazado (Repository::reinsertarFilasAprobadas).
		// Antes se enviaban y el backend intentaba emparejarlas con las filas de DB por una key derivada del
		// contenido; esa key no distingue dos líneas del mismo ítem+servicio+clasificación con cantidades
		// distintas (caso normal en mano de obra), así que colapsaban y se perdían unidades, descuadrando el
		// header contra los ítems. Se siguen mostrando en pantalla (bloqueadas), solo no viajan en el payload.
		// El total del header lo recalcula el backend desde las filas persistidas, así que no hace falta que
		// totalManoObra/totalRepuestos las contemplen.
		const esLineaAprobada = (linea) => (
			esRecotizacionParcial
			&& linea.estado_recotizacion !== 'nuevo'
			&& linea.estado_recotizacion !== 'rechazado'
		)
		const itemsAEnviar = trabajaConManoDeObra
			? presupuestoItems.concat(presupuestoItemsManoDeObra)
			: presupuestoItems
		formDataCopy.presupuestoItems = itemsAEnviar.filter(function (i) { return !esLineaAprobada(i) })
		formDataCopy.presupuestoTareas = presupuestoTareas.filter(function (t) { return !esLineaAprobada(t) })
		formDataCopy.adjunto = adjunto

		// En recotización parcial, incluir el ID del presupuesto existente para actualizar en lugar de crear
		if (presupuestoIdActual) {
			formDataCopy.idPresupuesto = presupuestoIdActual;
		}

		// VEC-3231: si se precargó un borrador, su 'adicional' (calculado por el backend con
		// existeAprobado) define el momento. Lo mandamos siempre — también al ENVIAR/promover — para
		// que el backend elija el nextState correcto (PRESUPUESTAR_ADIC vs PRESUPUESTAR) y transicione
		// el ticket. canDo('PRESUPUESTAR_ADIC') no es confiable acá (presupuestoIdActual ya está seteado).
		if (adicionalBorrador !== null) {
			formDataCopy.adicional = adicionalBorrador;
		} else if(!props.idPresupuesto && !presupuestoIdActual){
		    // VEC-3398: el prop autoritativo (existeAprobado) solo aplica con el flag de borrador ON.
		    // Con el flag OFF (flujo legacy) momentoAdicionalProp puede venir null/incorrecto y enviar
		    // adicional erróneo provoca 403; restauramos el fallback canDo('PRESUPUESTAR_ADIC').
		    if (borradorHabilitado && momentoAdicionalProp !== null) {
		        formDataCopy.adicional = momentoAdicionalProp;
		    } else {
		        formDataCopy.adicional = canDo('PRESUPUESTAR_ADIC') ? true : false;
		    }
		}

		// VEC-3231: el guardado de borrador (carga parcial) va a un endpoint dedicado que NO
		// transiciona el ticket; el guardado normal mantiene el endpoint de presupuestar.
		const url = esBorrador === true
			? `/ticket-presupuestos/ticket/${props.ticket.id}/borrador`
			: `/ticket-presupuestos/ticket/${props.ticket.id}`;

		// VEC-3203: el endpoint puede devolver el shape `{mensaje, context}` para errores 400.
		// Usamos `sendDataNoErrorMessage` (análogo a `getDataNoErrorMessage`) para evitar
		// que el flow legacy de `handleError` dispare un modal "Error" vacío antes de poder
		// traducir nosotros vía `translateBackendKey`.
		Utils.sendDataNoErrorMessage(url, 'POST', formDataCopy)
		.then(() => {
			// VEC-3231: el modal detallado NO se remonta tras guardar (su key modalPresupuestoKey no se
			// incrementa en el save), así que init() no se re-ejecuta. Al guardar un BORRADOR recargamos
			// su contenido en vez de resetear, para que se vea al reabrir (el estado del componente persiste).
			if (esBorrador) {
				init();
			} else {
				resetPresupuesto();
				setLoading(false)
			}
			props.callbackSave();
			props.callbackClose();
		})
		.catch((err) => {
			setLoading(false);
			var status = err && err.response ? err.response.status : null;
			var data = err && err.response && err.response.data ? err.response.data : null;
			// VEC-3203 shape: { mensaje: <i18n-key>, context: {...} }
			if (status === 400 && data && data.mensaje && backendStrings[data.mensaje]) {
				var mensajeTraducido = Utils.translateBackendKey(data.mensaje, data.context, intl);
				setErrors([mensajeTraducido]);
				Swal.fire({
					title: intl.formatMessage({ id: 'common.error', defaultMessage: 'Error' }),
					text: mensajeTraducido,
					type: 'error',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-primary',
					confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
				});
			} else if (data && data.detalle) {
				// Fallback al flow legacy basado en `detalle`.
				setErrors(Array.isArray(data.detalle) ? data.detalle : [data.detalle]);
			} else {
				// Fallback genérico para errores de red / 5xx (paridad con el modal que
				// dispararía Utils.sendData -> handleError si lo hubiéramos usado).
				Swal.fire({
					title: intl.formatMessage({ id: 'common.error', defaultMessage: 'Error' }),
					text: intl.formatMessage({ id: 'errors.default', defaultMessage: 'Ocurrió un error inesperado. Intente nuevamente.' }),
					type: 'error',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-primary',
					confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
				});
			}
		});
	}

	// VEC-3231: al guardar un borrador, el backend NO valida obligatorios (para permitir el borrador
	// automático al crear el ticket con ítems heredados incompletos). Pero desde el modal validamos en
	// el front los obligatorios SOLO de los boxes que el usuario puede editar; el box en solo lectura
	// NO se valida (sus ítems pueden venir heredados sin completar y el usuario no puede arreglarlos).
	// Etiqueta legible para cada campo obligatorio (la clave coincide con la propiedad del ítem/tarea).
	const etiquetaCampoObligatorio = (campo) => {
		const etiquetas = {
			id: { id: 'Presupuesto.Id', defaultMessage: 'Id' },
			descripcion: { id: 'Presupuesto.Descripción', defaultMessage: 'Descripción' },
			nombre: { id: 'Presupuesto.Descripción', defaultMessage: 'Descripción' },
			clasificacion: { id: 'Presupuesto.Clasificación', defaultMessage: 'Clasificación' },
			cantidad: { id: 'Presupuesto.Cantidad', defaultMessage: 'Cantidad' },
			precio: { id: 'Presupuesto.Precio', defaultMessage: 'Precio' },
			marca: { id: 'Presupuesto.Marca', defaultMessage: 'Marca' },
			servicio: { id: 'Presupuesto.Servicio', defaultMessage: 'Servicio' },
			detalle: { id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' },
			cuenta_mayor: { id: 'Presupuesto.Cuenta_Mayor', defaultMessage: 'Cuenta Mayor' },
			descrip_cuenta_mayor: { id: 'Presupuesto.descrip._Cuenta_Mayor', defaultMessage: 'Descrip. Cuenta Mayor' },
		};
		return etiquetas[campo] ? intl.formatMessage(etiquetas[campo]) : campo;
	};

	// Resuelve el valor de un campo obligatorio tolerando las distintas representaciones de un ítem/tarea:
	// los ítems agregados a mano usan las claves del form (servicio objeto, costo, marca), mientras que los
	// PRECARGADOS (heredados / borrador) llegan mapeados con otras claves (servicio_id/servicio_nombre,
	// costo, sin marca). Sin esta normalización, validar `item['servicio']` o `item['marca']` sobre un ítem
	// precargado daría undefined => siempre "faltante" => bloquearía guardar un borrador válido. La emptiness
	// se evalúa con esValorObligatorioFaltante (VEC-3436): 0 es válido solo para costo/precio, no para cantidad.
	const valorCampoObligatorio = (item, campo) => {
		switch (campo) {
			case 'servicio':      return item.servicio || item.servicio_id || item.servicio_nombre;
			case 'marca':         return item.marca || item.marca_id;
			case 'clasificacion': return item.clasificacion || item.id_clasificacion || item.id_item_clasificacion;
			case 'mecanico':      return (item.mecanico_ids && item.mecanico_ids.length) ? item.mecanico_ids : item.mecanico;
			// Los repuestos usan 'costo'; las tareas usan 'precio'. Soporta config que pida 'precio' o 'costo'.
			case 'precio':
			case 'costo':         return (item.costo !== undefined && item.costo !== null && item.costo !== '') ? item.costo : item.precio;
			default:              return item[campo];
		}
	};

	// VEC-3436: 0 (cero) es un valor válido SOLO para costo/precio; para el resto de los campos (cantidad, etc.)
	// el 0 sigue siendo faltante. Sin esto, `!valor` marcaba el 0 de costo como incompleto y bloqueaba el borrador.
	const esValorObligatorioFaltante = (campo, valor) => {
		if (campo === 'costo' || campo === 'precio') {
			return valor === undefined || valor === null || valor === '';
		}
		return !valor;
	};

	// Devuelve las etiquetas (sin duplicados) de los campos obligatorios incompletos en los boxes editables.
	const obtenerCamposObligatoriosFaltantes = () => {
		const faltantes = [];
		const acumularFaltantes = (lista, obligatorios) => {
			(lista || []).forEach(item => {
				(obligatorios || []).forEach(campo => {
					if (esValorObligatorioFaltante(campo, valorCampoObligatorio(item, campo)) && faltantes.indexOf(campo) === -1) {
						faltantes.push(campo);
					}
				});
			});
		};
		if (puedeRepuestos) acumularFaltantes(presupuestoItems, obligatoriosItem);
		if (trabajaConManoDeObra && puedeManoDeObra) acumularFaltantes(presupuestoItemsManoDeObra, obligatoriosItem);
		if (!trabajaConManoDeObra && puedeManoDeObra) acumularFaltantes(presupuestoTareas, obligatoriosTarea);
		return faltantes.map(etiquetaCampoObligatorio);
	};

	// Guardar como borrador (carga parcial). No requiere la advertencia de mezcla de validación
	// automática porque no presupuesta (no transiciona el ticket).
	const handleGuardarBorrador = () => {
		const camposFaltantes = obtenerCamposObligatoriosFaltantes();
		if (camposFaltantes.length > 0) {
			Swal.fire({
				title: intl.formatMessage({ id: 'ticketPresupuestoDetallado.borrador.camposObligatorios', defaultMessage: 'Campos obligatorios' }),
				text: intl.formatMessage(
					{ id: 'ticketPresupuestoDetallado.borrador.completarObligatorios', defaultMessage: 'Completá los siguientes campos obligatorios antes de guardar el borrador: {campos}.' },
					{ campos: camposFaltantes.join(', ') }
				),
				type: 'warning',
				buttonsStyling: false,
				confirmButtonClass: 'btn btn-primary',
				confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
			});
			return;
		}
		ejecutarGuardado(true);
	};

	const handleSubmit = () =>  {
		// VEC-2591: el botón Guardar valida los mismos obligatorios que el borrador (paridad). Así una
		// cantidad en 0 (obligatoria) tampoco se puede guardar acá; 0.1 sí pasa (0 solo es válido en costo/precio).
		const camposFaltantes = obtenerCamposObligatoriosFaltantes();
		if (camposFaltantes.length > 0) {
			Swal.fire({
				title: intl.formatMessage({ id: 'ticketPresupuestoDetallado.borrador.camposObligatorios', defaultMessage: 'Campos obligatorios' }),
				text: intl.formatMessage(
					{ id: 'ticketPresupuestoDetallado.guardar.completarObligatorios', defaultMessage: 'Completá los siguientes campos obligatorios antes de guardar: {campos}.' },
					{ campos: camposFaltantes.join(', ') }
				),
				type: 'warning',
				buttonsStyling: false,
				confirmButtonClass: 'btn btn-primary',
				confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
			});
			return;
		}
		// Detectar si hay mezcla de servicios con y sin validación automática
		if (ConfigBusiness.get('tickets.presupuesto.servicios.autoAprobacion') === 'true' && detectarMezclaValidacionAutomatica()) {
			const mensajeParte1 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte1', 
				defaultMessage: 'Este presupuesto contiene items/tareas con' 
			});
			const mensajeParte2 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte2', 
				defaultMessage: 'servicios de validación automática' 
			});
			const mensajeParte3 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte3', 
				defaultMessage: 'y otros de' 
			});
			const mensajeParte4 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte4', 
				defaultMessage: 'auto-aprobación por monto máximo' 
			});
			const mensajeParte5 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte5', 
				defaultMessage: 'Las líneas con validación automática se excluyen del total' 
			});
			const mensajeParte6 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte6', 
				defaultMessage: 'y el resto se evalúa contra el monto máximo, por lo que el presupuesto podría requerir aprobación manual.' 
			});
			const mensajeParte7 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte7', 
				defaultMessage: '¿Desea continuar?' 
			});

			const htmlMensaje = `${mensajeParte1} <b>${mensajeParte2}</b> ${mensajeParte3} <b>${mensajeParte4}</b>.<br/><br/><strong>${mensajeParte5}</strong> ${mensajeParte6}<br/><br/>${mensajeParte7}`;

			Swal.fire({
				title: intl.formatMessage({ id: 'Atencion', defaultMessage: 'Atención' }),
				html: htmlMensaje,
				type: 'warning', // correcto para sweetalert2 v7
				showCancelButton: true,
				confirmButtonColor: '#0ABFBC',
				cancelButtonColor: '#FF3145',
				confirmButtonText: intl.formatMessage({ id: 'Si_continuar', defaultMessage: 'Sí, continuar' }),
				cancelButtonText: intl.formatMessage({ id: 'Cancelar', defaultMessage: 'Cancelar' })
			  }).then((result) => {
				if (result.value) {
				  	ejecutarGuardado();
				}
			  });
			  
		} else {
			// No hay mezcla, proceder normalmente
			ejecutarGuardado();
		}
	}

	const resetPresupuesto = (data, index) => {
		setFormData({ ...FORM_DATA_INIT })
		setTotalRepuestos(0)
		setPresupuestoItems([]);
		setPresupuestoTareas([]);
		setPresupuestoItemsManoDeObra([]);
		setTotalManoDeObraItems(0);
		setTotalTareas(0);
		calculateTotal([],[], 0, 0)
		setImpuestos(0);
		setOtros(0);
		setAdjunto(0);
	}

	const canDo = (action) => {
		return props.actions.indexOf(action) >= 0;
	}

	const updateServicioItem = (data, index) => {
		presupuestoItems[index].cantidad = data.cantidad
		presupuestoItems[index].costo = data.costo
		presupuestoItems[index].detalle = data.detalle || ''
		if (data.clasificacion !== undefined) presupuestoItems[index].clasificacion = data.clasificacion;
		if (data.id_clasificacion !== undefined) presupuestoItems[index].id_clasificacion = data.id_clasificacion;
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros, presupuestoItemsManoDeObra);
	}

	const updatePresupuestoTarea = (data, index) => {
		if(data.cantidad !== undefined) presupuestoTareas[index].cantidad = data.cantidad;
		if(data.costo !== undefined) presupuestoTareas[index].precio = data.costo;
		if(data.detalle !== undefined) presupuestoTareas[index].detalle = data.detalle || '';
		if(data.mecanico_ids !== undefined) presupuestoTareas[index].mecanico_ids = data.mecanico_ids;
		if(data.clasificacion !== undefined) presupuestoTareas[index].clasificacion = data.clasificacion;
		if(data.id_clasificacion !== undefined) presupuestoTareas[index].id_clasificacion = data.id_clasificacion;
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros);
	}
	
	// VEC-3231: con la config de borrador habilitada, los permisos de precarga por tipo+momento son los
	// que definen qué puede cargar el usuario; NO hay fallback al permiso de envío. Si no tiene ninguno
	// de los 4 permisos para el momento, ambos boxes quedan en solo lectura aunque pueda enviar a
	// presupuestar. Con la config deshabilitada vale el comportamiento legacy (edición completa con
	// permiso de envío). El backend aplica la misma lógica — deben coincidir.
	// VEC-3231: el momento (inicial/adicional) lo define existeAprobado, que el backend expone en
	// /items-activos.adicional y el padre nos pasa como prop (momentoAdicional). Es la MISMA fuente que
	// usa el backend en guardarBorrador, así el griseo por tipo coincide con el enforcement del server.
	// NO se usa canDo('PRESUPUESTAR_ADIC'): depende de las transiciones de workflow disponibles (y de los
	// permisos de ENVÍO), no del momento real — un usuario con permiso de carga adicional pero sin la
	// transición de envío caía erróneamente en el momento inicial. Orden: borrador precargado > prop > canDo.
	const adicionalActual = adicionalBorrador !== null
		? adicionalBorrador
		: (momentoAdicionalProp !== null ? momentoAdicionalProp : canDo('PRESUPUESTAR_ADIC'));
	const puedeEnviar = Security.hasPermission('TICKETS_CARGAR_PRESUPUESTO') || Security.hasPermission('TICKETS_MODIFICAR_PRESUPUESTADOS');
	const permisoRepuestos = permisosCargaPorMomento(adicionalActual).repuestos;
	const permisoManoDeObra = permisosCargaPorMomento(adicionalActual).manoDeObra;
	const tieneCargaMomento = borradorHabilitado && (Security.hasPermission(permisoRepuestos) || Security.hasPermission(permisoManoDeObra));
	const puedeRepuestos = borradorHabilitado ? Security.hasPermission(permisoRepuestos) : puedeEnviar;
	const puedeManoDeObra = borradorHabilitado ? Security.hasPermission(permisoManoDeObra) : puedeEnviar;

  return (
	<React.Fragment>
	  	{redirectTo && <Redirect push to={redirectTo} />}
	  	{loading && <Loading />}
			<div>
				<div className="alert alert-danger" role="alert" hidden={errors.length===0}>
					{errors.map((e, i) => <li key={i}>{backendStrings[e] ? <FormattedMessage {...backendStrings[e]}/> : e}</li>)}
				</div>


				{enabledItems ? 
					<div className="card pull-up">
						<div className="card-content">
							<div className="card-body">
								<h4 className="form-section">
									<i className="la la-file-text"></i><FormattedMessage id="Repuesto" defaultMessage="Repuesto"/>
								</h4>
								<div className="row">
									<div className="col-md-12">
										<PresupuestoDetalladoItem
											ticket={props.ticket}
											tipoItem={trabajaConManoDeObra ? ITEM_TIPO_PRODUCTO : undefined}
											presupuestoItems={presupuestoItems}
											deleteItem={deleteServicioItem}
											addItemServicio={addPresupuestoRepuesto}
											totalRepuestos={totalRepuestos}
											updateServicioItem={updateServicioItem}
											showItems={showItems.filter(function(f) { return f !== 'mecanico'; })}
											obligatorios={obligatoriosItem}
											esRecotizacionParcial={esRecotizacionParcial}
											soloLectura={!puedeRepuestos}
										>
										</PresupuestoDetalladoItem>
									</div>
								</div>
							</div>
						</div>
					</div>
					: null
				}
				{trabajaConManoDeObra && enabledItems ?
					<div className="card pull-up">
						<div className="card-content">
							<div className="card-body">
								<h4 className="form-section">
									<i className="la la-file-text"></i>
									<FormattedMessage id="Mano_de_Obra" defaultMessage="Mano de Obra"/>
								</h4>
								<div className="row">
									<div className="col-md-12">
										<PresupuestoDetalladoItem
											ticket={props.ticket}
											tipoItem={ITEM_TIPO_MANO_DE_OBRA}
											presupuestoItems={presupuestoItemsManoDeObra}
											deleteItem={deletePresupuestoManoDeObraItem}
											addItemServicio={addPresupuestoManoDeObraItem}
											totalRepuestos={totalManoDeObraItems}
											updateServicioItem={updatePresupuestoManoDeObraItem}
											showItems={showItems}
											obligatorios={obligatoriosItem}
											esRecotizacionParcial={esRecotizacionParcial}
											soloLectura={!puedeManoDeObra}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					: null
				}
				{!trabajaConManoDeObra && enabledTareas ?
					<div className="card pull-up">
						<div className="card-content">
							<div className="card-body">
								<h4 className="form-section">
									<i className="la la-file-text"></i><FormattedMessage id={trabajaConManoDeObra ? "Tareas" : "Mano_de_Obra"} defaultMessage={trabajaConManoDeObra ? "Tareas" : "Mano de Obra"}/>
								</h4>
								<div className="row">
									<div className="col-md-12">
										<PresupuestoDetalladoTarea
											ticket={props.ticket}
											presupuestoTareas={presupuestoTareas}
											deleteTarea={deletePresupuestoTareas}
											addTarea={addPresupuestoTarea}
											totalManoObra={trabajaConManoDeObra ? totalTareas : totalManoObra}
											labelTotal={trabajaConManoDeObra ? "Total Tareas" : undefined}
											updatePresupuestoTarea={updatePresupuestoTarea}
											showTareas={showTareas}
											obligatorios={obligatoriosTarea}
											esRecotizacionParcial={esRecotizacionParcial}
											soloLectura={!puedeManoDeObra}
										>
										</PresupuestoDetalladoTarea>
									</div>
								</div>
							</div>
						</div>
					</div>
					: null
				}
				<div className="card pull-up">
					<div className="card-content">
						<div className="card-body">
							<h4 className="form-section">
								<i className="la la-file-text"></i>
							</h4>
							<div className="row">
								<div className="col-md-6">
									<div className="form-group row">
										<label className="col-md-12 label-control col-form-label text-left">
											<FormattedMessage id="Adjunto" defaultMessage="Adjunto"/>
											{ ConfigBusiness.get('tickets.presupuesto.adjuntoObligatorio') === 'true' ? requiredSymbol : ''}:
										</label>
										<div className="col-md-3"></div>
										<Dropzone actions={props.actions} setAdjunto={setAdjunto} guardarLog={false}></Dropzone>
									</div>
								</div>
								<div className="col-md-6">
									{ConfigBusiness.get('tickets.presupuesto.impuestos.habilitado')==="true" ?
										<div className="col-md-12">
											<div className="row p-1" style={{justifyContent: "right"}}>
												<label className="col-md-6 label-control col-form-label" htmlFor="impuestos">
													<FormattedMessage id="Impuestos" defaultMessage="Impuestos"/> :
												</label>
												<div className="col-md-6">
													<div>
														<input
															type="number"
															className="form-control text-right pr-1"
															id="impuestos"
															name="impuestos"
															value={formatCost(impuestos)}
															onChange={(e) => handleFormChangeImpuestos(e.target.value)}
														/>
													</div>
												</div>
											</div>
										</div>
									: null}
									{ConfigBusiness.get('tickets.presupuesto.otros.habilitado')==="true" ?
										<div className="col-md-12">
											<div className="row p-1" style={{justifyContent: "right"}}>
												<label className="col-md-6 label-control col-form-label" htmlFor="otros">
													<FormattedMessage id="Otros" defaultMessage="Otros"/> :
												</label>
												<div className="col-md-6">
													<div>
														<input
															type="number"
															className="form-control text-right pr-1"
															id="otros"
															name="otros"
															value={formatCost(otros)}
															onChange={(e) => handleFormChangeOtros(e.target.value)}
														/>
													</div>
												</div>
											</div>
										</div>
									: null}
									<div className="col-md-12">
										<div className="row p-1" style={{justifyContent: "right"}}>
											<label className="col-md-6 label-control col-form-label" htmlFor="total">
												<b><FormattedMessage id="Total" defaultMessage="Total"/></b> :
											</label>
											<div className="col-md-6">
												<div>
													<input disabled 
														type="number"
														className="form-control text-right pr-1"
														id="total"
														name="total"
														value={formatCost(total)}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="card pull-up">
					<div className="card-content">
						<div className="card-body">
						<div className="text-cd text-right">
							{tieneCargaMomento ? (
								<button
									type="button"
									className="btn btn-secondary mr-1"
									onClick={handleGuardarBorrador}
									disabled={validate() || loading}
								>
									<i className="fa fa-save"></i> <FormattedMessage id="ticketPresupuestoDetallado.guardarBorrador" defaultMessage="Guardar borrador"/>
								</button>
							) : ''}
							{(Security.hasPermission('TICKETS_CARGAR_PRESUPUESTO') || Security.hasPermission('TICKETS_MODIFICAR_PRESUPUESTADOS')) ? (
							<button
								type="submit"
								className="btn btn-primary mr-1"
								onClick={handleSubmit}
								disabled={validate() || loading}
							>
								{loading ? (
									<>
										<i className="fa fa-spinner fa-spin"></i> <FormattedMessage id="Guardando" defaultMessage="Guardando..."/>
									</>
								) : (
									<>
										<i className="fa fa-check-circle"></i> <FormattedMessage id="Guardar" defaultMessage="Guardar"/>
									</>
								)}
							</button>
							) : ''}
							<button type="button" className="btn btn-danger" onClick={handleCancel} disabled={loading}>
								<i className="fa fa-times-circle"></i> <FormattedMessage id="Cancelar" defaultMessage="Cancelar"/>
							</button>
						</div>
						</div>
					</div>
				</div>
			</div>
	</React.Fragment>
  );
};

export default injectIntl(TicketPresupuestoDetallado);
